import type { FC, ReactNode } from 'react'

import { ChatInputAttachmentMenu } from './chat-input-attachment-menu.molecule'
import { ChatInputAttachmentSheet } from './chat-input-attachment-sheet.molecule'

interface ChatInputToolbarAttachmentProps {
  isMobile: boolean
  isSheetOpen: boolean
  onSheetOpenChange: (open: boolean) => void
  onSelectFromComputer: () => void
  onSelectFromChats: () => void
  isDisabled: boolean
  isFileAttachEnabled?: boolean
}

/**
 * Attachment picker for the toolbar - shows sheet on mobile, menu on desktop.
 */
export const ChatInputToolbarAttachment: FC<ChatInputToolbarAttachmentProps> = ({
  isMobile,
  isSheetOpen,
  onSheetOpenChange,
  onSelectFromComputer,
  onSelectFromChats,
  isDisabled,
  isFileAttachEnabled = true,
}): ReactNode => {
  const isAttachDisabled = isDisabled || !isFileAttachEnabled
  const disabledReason = !isFileAttachEnabled
    ? 'This agent does not support file attachments'
    : undefined
  const attachmentProps = {
    onSelectFromComputer,
    onSelectFromChats,
    isDisabled: isAttachDisabled,
    disabledReason,
  }

  if (isMobile) {
    return (
      <ChatInputAttachmentSheet
        isOpen={isSheetOpen}
        onOpenChange={onSheetOpenChange}
        {...attachmentProps}
      />
    )
  }

  return <ChatInputAttachmentMenu {...attachmentProps} />
}

ChatInputToolbarAttachment.displayName = 'ChatInputToolbarAttachment'
